import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { modalStore } from 'src/mobx/modalStore';
import { getTranslate } from 'src/utils/helpers';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

export const CategoryMenuGroupsModal = (): JSX.Element => {
  const onCloseModal = () => {
    modalStore.closeCategoryMenuGroupsModal();
  };

  return (
    <CustomModalComponent isOpen onRequestClose={onCloseModal} withCloseIcon modalMaxWidth={432}>
      <ModalBackground>
        <ModalHeader title={localeStore.t('included_in_menu_groups')} />
        <ScrollableBlock className="d-flex flex-1 my-8" scrollClassName="d-flex flex-column px-8" showScrollbar scrollbarSize="small">
          {modalStore.categoryMenuGroupsModal?.menuGroups.map((menuGroup, index) => (
            <p key={menuGroup.id || 'key-' + String(index)} className="family-semibold text-size-16 color-dark mb-8">
              {getTranslate(menuGroup.name)}
            </p>
          ))}
        </ScrollableBlock>
      </ModalBackground>
    </CustomModalComponent>
  );
};
